<template>
    <section class="section section-lg technology-we-work">
        <div class="container">
            <div class="row row-grid justify-content-center mt--100">
                <div class="col-lg-8 text-center">
                    <h2 class="display-3">Não sabe qual tecnologia utilizar?
                        <span class="text-success">Nós te auxiliamos!</span>
                    </h2>
                    <p class="lead">
                      Ao iniciar um projeto conosco te auxiliamos na escolha da 
                      tecnologia que mais se adequa ao seu modelo de negócio.
                    </p>
                    <!--<div class="btn-wrapper">
                        <a href="#btn"
                           class="btn btn-primary mb-3 mb-sm-0">One Button</a>
                    </div>-->
                    <div class="text-center">
                        <h4 class="display-4 mb-5 mt-5">Essas são algumas das tecnologias com as quais nós trabalhamos:</h4>
                        <div class="row justify-content-center">
                            <div class="col-lg-2 col-4">
                                <a href="https://bootstrap-vue.org/" target="_blank" data-toggle="tooltip"
                                 data-original-title="Bootstrap 4 - Most popular front-end component library">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg'"
                                     class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://www.ruby-lang.org/pt/" target="_blank" data-toggle="tooltip"
                                   data-original-title="[Coming Soon] Sketch - Digital design toolkit">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/sketch.jpg'"
                                         class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://www.adobe.com/br/products/photoshop.html" target="_blank" data-toggle="tooltip"
                                   data-original-title="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg'"
                                         class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://v2.vuejs.org/" target="_blank" data-toggle="tooltip"
                                   data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/vue.jpg'"
                                         class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://angular.io/" target="_blank" data-toggle="tooltip"
                                    data-original-title="[Coming Soon] Angular - One framework. Mobile &amp; desktop">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/angular.jpg'"
                                     class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://pt-br.reactjs.org/" target="_blank" data-toggle="tooltip"
                                 data-original-title="[Coming Soon] React - A JavaScript library for building user interfaces">
                                    <img v-lazy="'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg'"
                                     class="img-fluid">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.technology-we-work {

}
</style>